import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IExportSettingInput } from '../models/export/export-setting-input.model';
import { IExportConfiguration } from '../models/export/export-configuration.model';
import { ILanguageText } from '../models/language/language-text.model';
import { IDocumentSession } from '../models/session/document-session.model';
import { IDocumentTypeText } from '../models/document/document-type-text.model';
import { ICadType } from '../models/document/cad-type.model';
import { IProductItem } from '../models/item/product-item.model';
import { IDocumentSimpleType } from '../models/document/document-simple-type.model';
import { IDocumentType } from '../models/document/document-type.model';

export const setInitialSession = createAction(
  '[MY_DOCUMENTS_STORE] SET_ID_TO_SESSION',
  props<{ id: string; orderNumber: string; language: string }>()
);

export const setDocumentSession = createAction(
  '[MY_DOCUMENTS_STORE] SET_DOCUMENT_SESSION',
  props<{ documentSession: IDocumentSession }>()
);

export const setSelectedDocumentTypes = createAction(
  '[MY_DOCUMENTS_STORE] SET_SELECTED_DOCUMENT_TYPES',
  props<{ documentTypes: IDocumentTypeText[] }>()
);

export const getAvailableDocumentTypes = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_DOCUMENT_TYPES',
  props<{ languageId: string }>()
);

export const getAvailableDocumentTypesSuccess = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_DOCUMENT_TYPES_SUCCESS',
  props<{ documentTypes: IDocumentType[] }>()
);

export const getAvailableDocumentTypesFailure = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_DOCUMENT_TYPES_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const setSelectedCadTypes = createAction(
  '[MY_DOCUMENTS_STORE] SET_SELECTED_CAD_TYPES',
  props<{ cadTypes: ICadType[] }>()
);

export const getAvailableCadTypes = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_CADT_TYPES',
  props<{ languageId: string }>()
);

export const getAvailableCadTypesSuccess = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_CAD_TYPES_SUCCESS',
  props<{ cadTypes: ICadType[] }>()
);

export const getAvailableCadTypesFailure = createAction(
  '[MY_DOCUMENTS_STORE] GET_AVAILABLE_CAD_TYPES_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const setSelectedProducts = createAction(
  '[MY_DOCUMENTS_STORE] SET_SELECTED_PRODUCT_ITEMS',
  props<{ products: IProductItem[] }>()
);

export const setAvailableLanguages = createAction(
  '[MY_DOCUMENTS_STORE] SET_AVAILABLE_LANGUAGES',
  props<{ languages: ILanguageText[] }>()
);

export const setSelectedLanguages = createAction(
  '[MY_DOCUMENTS_STORE] SET_SELECTED_LANGUAGES',
  props<{ languages: ILanguageText[] }>()
);

export const getExportSettings = createAction(
  '[MY_DOCUMENTS_STORE] GET_EXPORT_SETTINGS',
  props<{ sessionId: string; orderCode: string }>()
);

export const getExportSettingsSuccess = createAction(
  '[MY_DOCUMENTS_STORE] GET_EXPORT_SETTINGS_SUCCESS',
  props<{ settingsList: IExportSettingInput[] }>()
);

export const getExportSettingsFailure = createAction(
  '[MY_DOCUMENTS_STORE] GET_EXPORT_SETTINGS_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const getAllAvailableExportSettings = createAction(
  '[MY_DOCUMENTS_STORE] GET_ALL_AVAILABLE_EXPORT_SETTINGS',
  props<{ sessionId: string; orderCode: string }>()
);

export const getAllAvailableExportSettingsSuccess = createAction(
  '[MY_DOCUMENTS_STORE] GET_ALL_AVAILABLE_EXPORT_SETTINGS_SUCCESS',
  props<{ configuration: IExportConfiguration }>()
);

export const getAllAvailableExportSettingsFailure = createAction(
  '[MY_DOCUMENTS_STORE] GET_ALL_AVAILABLE_EXPORT_SETTINGS_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const updateSavedConfiguration = createAction(
  '[MY_DOCUMENTS_STORE] UPDATE_SAVED_CONFIGURATION',
  props<{ configuration: IExportConfiguration }>()
);

export const getZipSettingsForSession = createAction(
  '[MY_DOCUMENTS_STORE] GET_ZIP_SETTINGS_FOR_SESSION',
  props<{ sessionId: string; orderCode: string }>()
);

export const getZipSettingsForSessionSuccess = createAction(
  '[MY_DOCUMENTS_STORE] GET_ZIP_SETTINGS_FOR_SESSION_SUCCESS',
  props<{ configuration: IExportConfiguration }>()
);

export const getZipSettingsForSessionFailure = createAction(
  '[MY_DOCUMENTS_STORE] GET_ZIP_SETTINGS_FOR_SESSION_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const postExportSettings = createAction(
  '[MY_DOCUMENTS_STORE] POST_EXPORT_SETTINGS',
  props<{ sessionId: string; orderCode: string }>()
);

export const postExportSettingsSuccess = createAction(
  '[MY_DOCUMENTS_STORE] POST_EXPORT_SETTINGS_SUCCESS'
);

export const postExportSettingsFailure = createAction(
  '[MY_DOCUMENTS_STORE] POST_EXPORT_SETTINGS_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const postSaveExportConfiguration = createAction(
  '[MY_DOCUMENTS_STORE] POST_SAVE_EXPORT_CONFIGURATION',
  props<{ sessionId: string; orderNo: string, saveAsDefault: boolean, configuration: IExportConfiguration }>()
);

export const postSaveExportConfigurationSuccess = createAction(
  '[MY_DOCUMENTS_STORE] POST_SAVE_EXPORT_CONFIGURATION_SUCCESS'
);

export const postSaveExportConfigurationFailure = createAction(
  '[MY_DOCUMENTS_STORE]POST_SAVE_EXPORT_CONFIGURATION_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const postSaveUserEntries = createAction(
  '[MY_DOCUMENTS_STORE] POST_SAVE_USER_ENTRIES',
  props<{
    sessionId: string;
    orderNo: string;
    docLanguages: string;
    selectedProducts: string;
    documentTypes: IDocumentSimpleType[];
    documentSubTypes: IDocumentSimpleType[];
  }>()
);

export const postSaveUserEntriesSuccess = createAction(
  '[MY_DOCUMENTS_STORE] POST_SAVE_USER_ENTRIES_SUCCESS'
);

export const postSaveUserEntriesFailure = createAction(
  '[MY_DOCUMENTS_STORE]POST_SAVE_USER_ENTRIES_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const setCurrentStep = createAction(
  '[MY_DOCUMENTS_STORE] SET_CURRENT_STEP',
  props<{ currentStep: number }>()
);

export const setNeedToSaveSettings = createAction(
  '[MY_DOCUMENTS_STORE] SET_NEED_TO_SAVE_SETTINGS',
  props<{ saveSettings: boolean }>()
);
